export const ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_EMAIL: '/verify-email/:id/:hash',
  CHECKIN: '/check-in/:restaurantId/:tableId',
  DASHBOARD: '/dashboard',
  CLIENTS: '/clients',
  CLIENT_CONFIGURATION: '/clients/:clientId/configuration',
  RESERVATIONS: '/reservations',
  RESERVATIONS_CREATE: '/reservations/create',
  RESERVATIONS_EDIT: '/reservations/:id/edit',
  RESERVATIONS_CALENDAR: '/reservations/calendar',
  GUESTS: '/guests',
  RESTAURANTS: '/restaurants',
  RESTAURANT_HOURS: '/restaurants/:number/hours',
  RESTAURANT_TABLES: '/restaurants/:number/tables',
  USERS: '/users',
  LOGS: '/logs',
  LOGS_OCCUPANCY: '/logs/occupancy',
  LOGS_TOP_GUESTS: '/logs/top-guests',
  LOGS_CANCELLATIONS: '/logs/cancellations',
  SETTINGS_RATES: '/settings/rates',
  SETTINGS_CHILD_CATEGORIES: '/settings/child-categories',
  SETTINGS_CONFIGURATION: '/settings/configuration',
  SETTINGS_TEMPLATES: '/settings/templates',
  SETTINGS_SMTP: '/settings/smtp',
  SETTINGS_RECAPTCHA: '/settings/recaptcha',
  PROFILE: '/profile',
  CHANGE_PASSWORD: '/change-password',
  UNAUTHORIZED: '/unauthorized',
  NOT_FOUND: '/404',
  ROOT: '/',
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
